export default class ExpandableAccordion {
    constructor(block) {
        this.scrollToHeaderTimeout = 100;
        this.initialized = false;
        this.accordionItems = block.querySelectorAll('.accordion-list .accordion-item');
        this.accordionImages = block.querySelectorAll('[data-expandable-image]');
        this.activeItemKey = 0;
        this.toggleItems();
        this.openFirstItem();
        this.initialized = true;
    }
    openFirstItem() {
        const firstItem = this.accordionItems[0];
        const button = firstItem.querySelector('.accordion-header button');
        button.click();
    }
    scrollToHeader(tabHeader) {
        if (!this.initialized) {
            return;
        }
        setTimeout(() => {
            let shouldScroll = false;
            const mobileHeader = document.querySelector('.mobile-header');
            if (mobileHeader) {
                shouldScroll = getComputedStyle(mobileHeader).getPropertyValue('display') != 'none';
            }
            else {
                return;
            }
            if (!shouldScroll) {
                return;
            }
            const elementPosition = tabHeader.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - mobileHeader.offsetHeight;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }, this.scrollToHeaderTimeout);
    }
    toggleItems() {
        const self = this;
        this.accordionItems.forEach((item) => {
            const button = item.querySelector('.accordion-header button');
            const content = item.querySelector('.accordion-content');
            const tabHeader = item.querySelector('.accordion-header');
            const classOpen = 'is-open';
            if (!button)
                return;
            button.addEventListener('click', () => {
                self.activeItemKey = parseInt(item.getAttribute('data-expandable-id'));
                if (item.classList.contains(classOpen)) {
                    return false;
                    content.style.height = '0px';
                    content.addEventListener('transitionend', function () {
                        item.classList.remove(classOpen);
                    }, {
                        once: true
                    });
                }
                else {
                    // close other items
                    this.accordionItems.forEach((otherItem) => {
                        otherItem.classList.remove(classOpen);
                    });
                    this.accordionImages.forEach((image) => {
                        image.classList.remove(classOpen);
                        if (parseInt(image.getAttribute('data-expandable-image')) === self.activeItemKey) {
                            image.classList.add(classOpen);
                        }
                    });
                    item.classList.add(classOpen);
                    content.style.height = 'auto';
                    let height = content.clientHeight + 'px';
                    content.style.height = '0px';
                    setTimeout(function () {
                        content.style.height = height;
                    }, 0);
                    this.scrollToHeader(tabHeader);
                }
            });
        });
    }
}
const blocks = document.querySelectorAll('.block.two-columns-expandable');
blocks.forEach((block) => {
    new ExpandableAccordion(block);
});
